import React, { useState, useEffect } from 'react';
import Select from '@deprecated-ui/common/Select';
import Input from '@deprecated-ui/common/Input';
import { useDispatch, useSelector } from 'react-redux';
import { earningsEffects, earningsSelectors } from 'features/earnings/slice';

const { Option: SelectOption, OptGroup } = Select;

const SectorSearch = () => {
  const dispatch = useDispatch();

  const [filteredSectors, setFilteredSectors] = useState([]);
  const [visible, setVisible] = useState(false);

  const {
    screenerUniverse: { data },
    earnings: {
      data: { order, sortcol, year, quarter, keyword },
    },
  } = useSelector(earningsSelectors);

  const { index, sectors } = data;

  const filterSector = (query) =>
    sectors.filter(
      (el) => JSON.stringify(el.subsector).toLowerCase().includes(query),
      // eslint-disable-next-line function-paren-newline
    );

  const onTypeHandler = (e) => {
    const query: string = e.target.value;
    if (query.length !== 0) {
      const newFilteredSectors = filterSector(query);
      setFilteredSectors(newFilteredSectors);
    } else {
      setFilteredSectors([]);
    }
  };

  const dropdownSectorSearch = (dropdownItem) => (
    <>
      <Input
        // @ts-expect-error
        mx="8px"
        width="calc(100% - 16px)"
        id="input-sector"
        onChange={onTypeHandler}
      />
      {dropdownItem}
    </>
  );

  const getData = (filter: string = undefined) => {
    dispatch(
      earningsEffects.getEarnings({
        order: order || 'asc',
        sortcol,
        page: '1',
        quarter: quarter.toString(),
        year,
        companySymbol: keyword || undefined,
        filter,
      }),
    );
  };

  const onSelectHandler = (name: string, attributes) => {
    const { key } = attributes;
    if (key === 'IHSG') {
      getData();
      setVisible(false);
      return;
    }

    getData(key);
    setVisible(false);
  };

  const recomposeSectors = () => {
    if (filteredSectors.length) {
      return filteredSectors?.map(({ name, id: idSect, subsector }) => (
        <>
          <SelectOption value={name} key={idSect}>
            {name}
          </SelectOption>

          {subsector.map(({ id: idSub, name: nameSub }) => (
            <SelectOption
              value={nameSub}
              key={idSub}
              style={{ paddingLeft: '32px', fontFamily: 'ProximaNovaRg' }}
            >
              {nameSub}
            </SelectOption>
          ))}
        </>
      ));
    }

    return sectors?.map(({ name, id: idSect, subsector }) => (
      <>
        <SelectOption value={name} key={idSect}>
          {name}
        </SelectOption>

        {subsector.map(({ id: idSub, name: nameSub }) => (
          <SelectOption
            value={nameSub}
            key={idSub}
            style={{ paddingLeft: '32px', fontFamily: 'ProximaNovaRg' }}
          >
            {nameSub}
          </SelectOption>
        ))}
      </>
    ));
  };

  const handleClick = (e) => {
    e.stopPropagation();
    const mainLayout = document.querySelector('#main-container');
    const { target } = e;
    const targetId = target.id;
    const targetClassname = target.className;

    if (!visible) {
      if (
        targetClassname === 'ant-select-selection-item' &&
        mainLayout.contains(target)
      ) {
        setVisible(true);
        return;
      }
    }

    if (visible) {
      if (targetId !== 'input-sector') {
        setVisible(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [visible]);

  return (
    <Select
      className="sector-search"
      defaultValue="IHSG"
      // @ts-expect-error
      name="stockUniverse"
      width="50%"
      dropdownRender={dropdownSectorSearch}
      showArrow
      onSelect={onSelectHandler}
      open={visible}
      onFocus={() => setVisible(true)}
    >
      {/* <OptGroup> */}
      {index?.map(({ name }) => (
        <SelectOption value={name} key={name}>
          {name}
        </SelectOption>
      ))}
      {/* </OptGroup> */}
      <OptGroup label="Sectors">{recomposeSectors()}</OptGroup>
    </Select>
  );
};

export default SectorSearch;
